import repository from '@/utils/repository';

export default {
    searchMst001Info: (data) => {
        return repository.post('/move/postCommonMst001Info', {
            ...data
        });
    }
};
